import { DateTimeHelper } from '../helpers';
import Bookings from './bookings/Bookings';
import { BookingI } from './bookings/Booking';
import { ApiAttachment, UploadingFile } from './MainFiles';
import { AuthUserI } from './AuthUser';
import {
  EachAssigneesOriginalRes,
  EachAssigneesRes,
} from './Assignees';
import { Statuses, StatusI } from './Statuses';
import Urgency from './Urgency';
import { EachWorkdeskTicketI } from 'store/models/workdesk-tickets/each-workdesk-ticket.interface';
import { CommonPagesI } from './file-selected/CommonPages';
import config from '../../config/main-page';
import { frontendDefaultSiKind } from './SiKind';
import { isNullOrUndefined } from 'utils';

const parseFromEmail = (input: string): string => {
  if (!input) return input;
  const reg = /<(.*?)>/;
  const m = input.match(reg);
  return m && m.length > 1 ? m[1] : input;
};

// const parsecustomerEmailAddr = (input: string): string => {
//   const reg = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g;
//   const matched = input.match(reg);
//   return matched ? matched.join(',') : '';
// };

// const ticketIdRegex = /\b([0-9A-Fa-f]{16})\b/gm;
const ticketIdRegexFromStart = /(^\b([0-9A-Fa-f]{16})\b)((?:,)\b([0-9A-Fa-f]{16})\b)?/gm;

export interface ToAutosaveApiI {
  timezone?: number;
  bookingNo: string;
  split: boolean;
  bookings: any; // TODO: update
  urgency: string;
  siKind: string;
  customerEmailAddr: string;
  comment: string;
}

/*
      bookingNo: string;
      split: boolean;
      bookings: any; // TODO: update
      urgency: string;
      siKind: string;
      customerEmailAddr: string;
      comment: string;
*/

export interface JustTicketLoadResDataI {
  inbox: string;
  attachments: ApiAttachment[];
  bookingNo: string;
  bookingNos: string[];
  senderId: string;
  id: string;
  si: boolean;
  autoSave: { data: any; updateDate: any; savedAlready: boolean };

  destinationEmail: string;
  messageInfo: {
    headers: {
      from: string;
      to: string;
    };
    subject: string;
    bodyPreview: { status: string; url: string }; // check if have to remove
    bodyHtmlLink: string;
  }; // TODO: come back to change
  status: StatusI;
}
export interface TicketLoadResDataI {
  assignee?: null | EachAssigneesOriginalRes;
  ticket: JustTicketLoadResDataI;
  adminAccess: boolean;
}

/**
 * /ticket/load's ticket value
 * note /ticket/load returns { adminAccess: boolean, ticket: TicketApiData , assignee: any }
 */
export interface TicketApiData {
  inbox: string;
  attachments: ApiAttachment[];
  bookingNo: string;
  bookingNos: string[];
  senderId: string;
  assignee?: EachAssigneesRes | null; // for now it doesn't have assignee yet
  id: string;
  si: boolean;
  autoSave: {
    data: any; // bookings is in here
    updateDate: any;
    savedAlready: boolean;
  };
  destinationEmail: string;
  messageInfo: {
    headers: {
      from: string;
      to: string;
    };
    subject: string;
    bodyPreview: { status: string; url: string }; // check if have to remove
    bodyHtmlLink: string;
  }; // TODO: come back to change
  status: StatusI;
  adminAccess: boolean;
}

export interface TicketDataFromMainPage {
  ticket: TicketApiData; // assignee, si is in here
  savedAlready: boolean;
  bookings?: BookingI[];

  id: string;
  bookingNo?: string; // is there booking nos?
  isSplit?: boolean;
  fromEmailTo: string;
  fromEmailFrom: string;
  fromEmailSubject: string;
  urgency: string;
  siKind: string;
  senderId: string;
  customerEmailAddr: string;
  commentToDoc: string;

  attachments?: ApiAttachment[]; // TODO: check if this is this actually there
  files?: UploadingFile[]; // TODO: revisit
  autoSave?: { data: any; updateDate: any }; // need this?

  commonPages?: CommonPagesI; // current before autosaved

  bodyPreviewUrl?: string;
  bodyPreviewUrlIsLoading?: boolean;
  bodyHtmlLink?: string;
  destinationEmail?: string;

  recommendedSiKind?: string;
  recommendedUrgency?: string;

  defaultSiKind: string;
  defaultUrgency: string;
}

export interface SubmitBookingParamsI {
  id: string;
  wantEmailResponse: boolean;
  timezone: number;
  bookingNo: string;
  bookings: BookingI[];
  data: {
    urgency: string;
    siKind: string;
    senderId: string | null;
    customerEmailAddr: string;
    comment: string;
    split?: boolean;
  };
  preview: boolean;
}

/**
 * from MainPage
 * for /submitBooking
 */
export class Ticket {
  static apiAttachmentsToStoreAttachments(
    attachments: ApiAttachment[] | undefined,
    recycledAttachmentPartIds: string[] | undefined,
  ) {
    if (!attachments) return [];
    if (!recycledAttachmentPartIds) recycledAttachmentPartIds = [];

    let data: ApiAttachment[] = attachments || [];
    return data.map((d) => {
      let isRecycled = d.isRecycled ?? false;
      if (!isNullOrUndefined(recycledAttachmentPartIds)) {
        isRecycled = (recycledAttachmentPartIds as string[]).includes(
          d.partId,
        );
      }
      return {
        ...d,
        isSelected: false,
        isRecycled,
      };
    }) as UploadingFile[];
  }
  static apiToStoreAttachments(ticket?: TicketApiData) {
    if (!ticket) return [];
    const { attachments = [] } = ticket;
    const recycledAttachmentPartIds = Ticket.apiToRecycledAttachmentPartIds(
      ticket,
    );
    return Ticket.apiAttachmentsToStoreAttachments(
      attachments,
      recycledAttachmentPartIds,
    );
  }
  static storeAttachmentsToRecycledAttachmentPartIds(
    attachments: ApiAttachment[],
  ): string[] {
    return attachments
      .filter((att) => !!att.isRecycled)
      .map((att) => att.partId);
  }
  static apiToRecycledAttachmentPartIds(
    ticket?: TicketApiData,
  ): string[] {
    if (!ticket) return [];
    return ticket.autoSave?.data?.recycledAttachmentPartIds ?? [];
  }
  /**
   * should work for both the workdesk and main page
   * @param ticket
   */
  static canAssignTicket(
    ticket: TicketApiData | EachWorkdeskTicketI,
  ) {
    return Ticket.canAssignUnassign(ticket.status, ticket.si);
  }

  static canAssignUnassign(status: StatusI, si: boolean) {
    if (!si) return false;
    return Statuses.canAssignUnassign(status);
  }

  static canAssign(
    status: StatusI,
    si: boolean,
    exceptIndexing = false,
  ): boolean {
    if (!si) return false;
    return Statuses.canAssign(status, exceptIndexing);
  }

  static canUnassign(status: StatusI): boolean {
    return Statuses.canUnassign(status);
  }

  static statusAfterSubmit = 'SENDING' as StatusI;
  static isTicketId(text: string) {
    return text.match(ticketIdRegexFromStart);
  }

  static formatFormUrgency(urgency: string, inbox: string): string {
    return urgency ?? Urgency.getDefaultUrgencyForInboxAddress(inbox);
  }

  static formToAutosaveApi(
    formData: TicketDataFromMainPage | null,
    originalData: TicketDataFromMainPage | any,
    recycledAttachmentPartIds?: string[],
  ): {
    data: ToAutosaveApiI;
    changeFlag: boolean;
    extraData: {
      status: string;
      si: boolean;
    };
  } | null {
    if (!formData) return null;
    let changeFlag = false;
    // TODO: create a helper for this
    const originalBookingNos =
      originalData?.ticket?.autoSave?.data?.bookings?.map(
        (b) => b.bookingNo,
      ) ||
      originalData?.bookingNos ||
      [];
    let newBookingNos;
    if (
      formData.bookingNo !== originalData?.bookingNo ||
      formData.urgency !== originalData?.urgency ||
      formData.siKind !== originalData?.siKind
    ) {
      changeFlag = true;
    } else if (
      formData.bookings?.length !== originalBookingNos.length
    ) {
      changeFlag = true;
    } else if (formData.bookings && originalBookingNos) {
      newBookingNos = formData.bookings.map((b) => b.bookingNo);
      changeFlag = newBookingNos.some(
        (newNo) => !originalBookingNos.includes(newNo),
      );
    }

    const bookings = Bookings.formToAutosaveApi(formData.bookings);
    const bookingNos = bookings.map((b) => b.bookingNo);

    const toAutosave = {
      timezone: DateTimeHelper.getTimezone(),
      bookingNo: Ticket.formToAutosaveOrSubmitBookingNo(formData),
      bookingNos,
      split: formData.isSplit ?? false, // api requires split
      bookings, // TODO: format bookings
      urgency: Ticket.formatFormUrgency(
        formData.urgency,
        formData.ticket?.inbox,
      ),
      recycledAttachmentPartIds,
      siKind: formData.siKind,
      customerEmailAddr: formData.customerEmailAddr,
      comment: formData.commentToDoc,

      // new
      commonPages:
        formData.commonPages || formData.autoSave?.data?.commonPages,
    };
    const extraData = {
      status: formData.ticket?.status,
      si: formData.ticket?.si,
    };
    console.debug(`callhandleSaveTicketIfCanEdit Ticket`, {
      formData,
      originalData,
      toAutosave,
      formDataIsSplit: formData?.isSplit,
      originalDataIsSplit: originalData?.isSplit,
    });
    return {
      data: toAutosave,
      changeFlag,
      extraData,
    };
  }
  static isFormSenderIdEmpty(formData: TicketDataFromMainPage) {
    return (
      !formData || !formData.senderId || formData.senderId === '-'
    );
  }
  static formToSubmitBookingApi(
    formData: TicketDataFromMainPage,
    preview: boolean = false,
  ): SubmitBookingParamsI {
    return {
      id: formData.id,
      wantEmailResponse: false,
      timezone: DateTimeHelper.getTimezone(),
      bookingNo: Ticket.formToAutosaveOrSubmitBookingNo(formData),
      bookings: Bookings.formToSubmitBookingApi(
        formData.bookings,
        formData.ticket.attachments,
      ), // TODO: format bookings (or might create another selector)
      data: {
        urgency: Ticket.formatFormUrgency(
          formData.urgency,
          formData.ticket?.inbox,
        ),
        siKind: formData.siKind,
        senderId:
          formData.senderId === '-' ? null : formData.senderId, // backend will pull ticket?
        customerEmailAddr: formData.customerEmailAddr,
        comment: formData.commentToDoc,
        split: formData.isSplit,
      },
      preview,
    };
  }

  static isFormDataMulti(formData: TicketDataFromMainPage): boolean {
    if (!formData?.bookings) return false;
    return formData.bookings.length > 1;
  }

  static formToAutosaveOrSubmitBookingNo(
    formData: TicketDataFromMainPage | null,
  ): string {
    if (!formData) return '';
    if (Ticket.isFormDataMulti(formData)) {
      return '';
    } else {
      if (formData?.bookings?.length) {
        return formData.bookings[0].bookingNo || '';
      }
    }
    return formData.bookingNo || '';
  }

  /**
   * if is multi top left should be blank
   * @param apiData
   * @returns
   */
  static apiToFormBookingNo(apiData: TicketApiData): string {
    let oriBookingNo;
    if (apiData.autoSave?.data?.bookingNo === undefined) {
      if (apiData.autoSave?.data?.bookingNos?.length) {
        oriBookingNo = apiData.autoSave.data.bookingNos[0];
      } else if (apiData.bookingNo !== undefined) {
        oriBookingNo = apiData.bookingNo;
      } else {
        oriBookingNo = apiData.bookingNos.length
          ? apiData.bookingNos[0]
          : '';
      }
    } else {
      oriBookingNo = apiData.autoSave?.data?.bookingNo;
    }
    // if multi  top left should be blank
    if (apiData.bookingNos.length > 1) {
      oriBookingNo = '';
    }
    return oriBookingNo;
  }

  static apiHasAutosaveData(apiData: TicketApiData): boolean {
    if (!apiData) return false;
    return apiData.autoSave?.savedAlready === true;
  }
  /**
   * this will used by selector
   * TODO: maybe should refactor this because ticket inside is redundant
   */
  static apiToForm(
    data?: TicketApiData,
  ): TicketDataFromMainPage | null {
    if (!data) return null;
    // question: should we have bookings in here? or not because it's already in the curbookings?
    return {
      ticket: data,
      id: data.id,
      bookings: undefined,
      bookingNo: Ticket.apiToFormBookingNo(data),
      // still need bodyPreviewUrl for pdf version
      bodyPreviewUrl:
        data.messageInfo.bodyPreview &&
        data.messageInfo.bodyPreview.url,
      bodyPreviewUrlIsLoading:
        !data.messageInfo.bodyPreview ||
        (data.messageInfo.bodyPreview &&
          data.messageInfo.bodyPreview.status !== 'Ready'),
      bodyHtmlLink: data.messageInfo.bodyHtmlLink,
      destinationEmail: data.destinationEmail,
      senderId: data.senderId,
      fromEmailFrom: data.messageInfo?.headers?.from,
      fromEmailTo: data.messageInfo?.headers?.to,
      isSplit: Ticket.apiIsSplitTicket(data),
      // ------ autosave related ------
      savedAlready: Ticket.apiHasAutosaveData(data),
      siKind:
        Ticket.apiToSiKindValue(data) ??
        Ticket.apiToDefaultSiKind(data),
      urgency:
        Ticket.apiToUrgencyValue(data) ??
        Ticket.apiToDefaultUrgency(data),
      customerEmailAddr:
        data.autoSave?.data?.customerEmailAddr ??
        parseFromEmail(data.messageInfo?.headers?.from),
      commentToDoc: data.autoSave?.data?.comment,
      fromEmailSubject: data.messageInfo?.subject,
      // ------- recommended related ------
      recommendedSiKind: Ticket.apiToRecommendedSiKind(data),
      recommendedUrgency: Ticket.apiToRecommendedUrgency(data),
      // ------- default value ------
      defaultSiKind: Ticket.apiToDefaultSiKind(data),
      defaultUrgency: Ticket.apiToDefaultUrgency(data),
    };
  }

  static apiToSiKindValue(data) {
    return data.autoSave?.data && data.autoSave?.data?.siKind;
  }

  static apiToUrgencyValue(data) {
    return data.autoSave?.data && data.autoSave?.data?.urgency;
  }

  static apiToDefaultSiKind(data) {
    // user selected value or detected value from backend or default from frontend
    const autoSaveSiKind = Ticket.apiToSiKindValue(data);
    if (autoSaveSiKind) return autoSaveSiKind;
    const recommendedSiKind = Ticket.apiToRecommendedSiKind(data);
    if (recommendedSiKind) return recommendedSiKind;
    return frontendDefaultSiKind;
  }

  static apiToDefaultUrgency(data) {
    // user selected value or detected value from backend or default from frontend
    const autoSaveUrgency = Ticket.apiToUrgencyValue(data);
    if (autoSaveUrgency) return autoSaveUrgency;
    const recommendedUrgency = Ticket.apiToRecommendedUrgency(data);
    if (recommendedUrgency) return recommendedUrgency;
    const urgencyForInboxAddress = Urgency.getDefaultUrgencyForInboxAddress(
      data.inbox,
    );
    return urgencyForInboxAddress;
  }

  static apiToRecommendedSiKind(data) {
    return data.detectedSiKind;
  }

  static apiToRecommendedUrgency(data) {
    return data.detectedUrgency;
  }

  /**
   * use old formdata for any key if the value in the new formatted ticket is undefined
   * make sure to test
   * click split -> upload file -> split must stay the same
   * change urgency and si kind -> uplaod file -> urgency and si kind must stay the same
   * in si ready -> assign. must be able to assign, not freeze
   * TODO: write test for this function
   * @param oldFormData
   * @param formattedTicket
   * @returns
   */
  static mergeFormData(
    oldFormData: TicketDataFromMainPage,
    formattedTicket: TicketDataFromMainPage,
  ): TicketDataFromMainPage {
    let final: TicketDataFromMainPage;
    if (!oldFormData) final = formattedTicket;
    else {
      // console.debug(
      //   '>> mergeFormData. old assignee',
      //   oldFormData?.ticket?.assignee,
      //   'new',
      //   formattedTicket?.ticket?.assignee,
      // );
      final = Object.entries(formattedTicket).reduce(
        (acc, [key, value]) => {
          let newValue;
          // always replace value if the new value is under ticket key (value is typeof object)
          // need to do this so after click assign, the value is replaced
          // or can consider taking the assignee up one level (out of the ticket)
          let hasOldValue =
            key !== 'ticket' &&
            oldFormData[key] !== undefined &&
            oldFormData[key] !== null;
          let oldValue = oldFormData[key];
          if (hasOldValue) {
            newValue = oldValue;
          } else {
            switch (key) {
              case 'siKind':
                newValue = formattedTicket.defaultSiKind;
                break;
              case 'urgency':
                newValue = formattedTicket.defaultUrgency;
                break;
              case 'isSplit':
                // why is this in here and not in apiToForm?
                newValue = Ticket.apiIsSplitTicket(
                  formattedTicket.ticket,
                  false,
                );
                break;
              case 'customerEmailAddr':
                // why is this in here and not in apiToForm?
                newValue = parseFromEmail(
                  formattedTicket.ticket.messageInfo?.headers?.from,
                );
                break;
              default:
                newValue = value;
                break;
            }
          }
          acc[key] = newValue;

          return acc;
        },
        {} as TicketDataFromMainPage,
      );
    }
    const finalAssignee = final?.ticket?.assignee;
    console.debug(`>> mergeFormData. result`, {
      finalAssignee,
      oldFormData,
      final,
    });
    return final;
  }

  static canViewTicket(
    data: TicketApiData | TicketDataFromMainPage,
  ): boolean {
    return Statuses.isReadyToViewStatus(
      (data as TicketDataFromMainPage)?.ticket?.status ||
        (data as TicketApiData).status,
    );
  }

  /**
   * can edit if has assignee and assignee is me
   * @param apiData
   * @param user
   */
  static canEditTicket(
    apiData: TicketApiData,
    user?: AuthUserI,
  ): boolean {
    return (
      (config.considerAdminAccess &&
        apiData &&
        apiData.adminAccess) ||
      (apiData &&
        apiData.assignee &&
        user &&
        apiData.assignee.id === user?.id) ||
      false
    );
  }

  /**
   * can edit if assignee id is the same as user id
   * @param apiData
   * @param user
   * @returns
   */
  static canNonAdminEditTicket(
    apiData: TicketApiData,
    user?: AuthUserI,
  ): boolean {
    return (
      (apiData &&
        apiData.assignee &&
        user &&
        apiData.assignee.id === user?.id) ??
      false
    );
  }

  static apiIsSplitTicket(
    ticketData,
    defaultV = undefined as undefined | boolean,
  ): boolean | undefined {
    return ticketData.autoSave?.data?.split ?? defaultV;
  }

  /******************* viewing ticket id *******************/
  static viewingTicketIdLocalStorageKey = 'viewingTicketId';

  static saveViewingTicketIdToLocalStorage(ticketId: string) {
    if (!ticketId) {
      console.error(`no ticketId so do not set`);
      return;
    }
    localStorage.setItem(
      Ticket.viewingTicketIdLocalStorageKey,
      ticketId,
    );
  }

  static getViewingTicketIdFromLocalStorage() {
    return localStorage.getItem(
      Ticket.viewingTicketIdLocalStorageKey,
    );
  }

  static clearViewingTicketIdFromLocalStorage() {
    localStorage.removeItem(Ticket.viewingTicketIdLocalStorageKey);
  }
}
